import React from 'react';
import { Box, Checkbox, CircularProgress, FormControlLabel, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { useFormikContext } from 'formik';
import { CreatWidgetFormValues, KeyLinkType } from '../../dashboard-widget-model';
import {
  KeyLinkOption,
  keyLinkKey,
  useKeyLinkOptions,
} from '../../../widgets/table-widget/key-links-table-widget/useKeyLinkOptions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      color: theme.color.grey.neutral500,
      fontWeight: 700,
      fontSize: '18px',
      marginBottom: '8px',
    },
    subtitle: {
      fontSize: '14px',
      color: theme.color.grey.neutral300,
      marginBottom: '16px',
    },
    label: {
      fontSize: '14px',
      fontWeight: 700,
      color: theme.color.grey.neutral500,
      marginTop: '12px',
    },
    expired: {
      fontSize: '12px',
      color: theme.color.grey.neutral300,
      marginLeft: '8px',
    },
  })
);

const groups: { type: KeyLinkType; label: string }[] = [
  { type: 'apply', label: 'General' },
  { type: 'form', label: 'Forms' },
  { type: 'funnel', label: 'Funnels' },
];

export const KeyLinksForm = () => {
  const classes = useStyles();
  const { options, loading } = useKeyLinkOptions();
  const { values, setFieldValue } = useFormikContext<CreatWidgetFormValues>();
  const selected = values.keyLinks ?? [];
  const selectedKeys = new Set(selected.map(keyLinkKey));

  const onToggle = (option: KeyLinkOption) => {
    const key = keyLinkKey(option);
    setFieldValue(
      'keyLinks',
      selectedKeys.has(key)
        ? selected.filter((link) => keyLinkKey(link) !== key)
        : selected.concat({ type: option.type, id: option.id })
    );
  };

  return (
    <Box>
      <Typography className={classes.title}>Links</Typography>
      <Typography className={classes.subtitle}>Links show on the widget in the order you select them.</Typography>
      {loading ? (
        <CircularProgress size={24} />
      ) : (
        groups.map(({ type, label }) => {
          const groupOptions = options.filter((option) => option.type === type);
          if (groupOptions.length === 0) return null;
          return (
            <Box key={type}>
              <Typography className={classes.label}>{label}</Typography>
              {groupOptions.map((option) => (
                <Box key={keyLinkKey(option)}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color='primary'
                        checked={selectedKeys.has(keyLinkKey(option))}
                        onChange={() => onToggle(option)}
                      />
                    }
                    label={
                      <>
                        {option.label}
                        {!option.isActive && <span className={classes.expired}>Expired</span>}
                      </>
                    }
                  />
                </Box>
              ))}
            </Box>
          );
        })
      )}
    </Box>
  );
};
